var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Settings", {
    staticClass: "block-settings",
    attrs: {
      region: "left",
      title: _vm.resource("TemplateBlockSettings_Settings_Title"),
      tooltip: _vm.tooltip
    },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function() {
          return [
            _c("settings-slider", {
              attrs: {
                label: _vm.resource(
                  "TemplateBlockSettings_Settings_Width_Label"
                ),
                value: _vm.width,
                min: 250,
                max: 900,
                "value-suffix": "px"
              },
              on: {
                input: function($event) {
                  return _vm.$emit("change-width", $event)
                }
              }
            }),
            _vm._v(" "),
            _c("settings-color-picker", {
              attrs: {
                label: _vm.resource(
                  "TemplateBlockSettings_Settings_Color_Label"
                ),
                value: _vm.color
              },
              on: {
                input: function($event) {
                  return _vm.$emit("change-color", $event)
                }
              }
            }),
            _vm._v(" "),
            _c("settings-color-picker", {
              attrs: {
                label: _vm.resource(
                  "TemplateBlockSettings_Settings_Border_Color_Label"
                ),
                value: _vm.borderColor
              },
              on: {
                input: function($event) {
                  return _vm.changeBorder($event)
                }
              }
            }),
            _vm._v(" "),
            _c("settings-slider", {
              attrs: {
                label: _vm.resource(
                  "TemplateBlockSettings_Settings_Border_Radius_Label"
                ),
                value: _vm.radius,
                "value-suffix": "px"
              },
              on: {
                input: function($event) {
                  return _vm.$emit("change-radius", $event)
                }
              }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }